// Numeric z-index values for APIs that require numbers (Framer Motion, ReactModal).
export const zIndexes = {
    sceneContentAnimatingCenter: 1, // z-index hierarchy: 0
    sceneContentAnimatingExit: 0, // z-index hierarchy: -
    modal: 60, // z-index hierarchy: 60
};

// Tailwind z-index classes for className props. Keep in sync with zIndexes above.
export const zIndexClasses = {
    siteBackground: "z-[-1]", // -1: behind all text
    sceneBottom: "z-[2]", //  2
    flush: "z-[4]", //  4: search widget
    flushIcon: "z-[5]", //  5: search icon
    barcodeButton: "z-[5]", //  5: above search
    touchHandler: "z-[5]", //  5: canvas overlay for touch
    dragHandler: "z-[15]", // 15: above touch handler
    burger: "z-[58]", // 58: burger icon below menu
    sceneModalBackdrop: "z-[59]", // 59: dark backdrop over manager menu
    sceneModal: "z-[59]", // 59: modal scene back button
    notifications: "z-[61]", // 61: above modal
    menu: "z-[65]", // 65: above everything
    fullWidthFooter: "z-[-1]", // -1: home page footer background
} as const;

export const colors = {
    text: "#181a1b",
    // A little lighter.
    header: "#373A3C",
    textMuted: "#777777",
    textHighlight: "#EF8165",
    brand: "#EF8165",
    footer: "#F7F9FA",
    primary: "#E2F4FB",
    border: "#D8D8D8",
    background: "bg-stone-50",
    success: {text: "#2c755f", border: "#50BD9C", background: "#DCF2EB"},
    info: {text: "#31708f", border: "rgb(196,227,243)", background: "#d9edf7"},
    warning: {text: "#8a6d3b", border: "rgb(248, 226, 181)", background: "#fcf8e3"},
    error: {text: "rgb(230, 32, 32)", border: "#EE6565", background: "#F5E4E4"},

    // TODO: these colors are all over the place.
    trend: {line: "#488EA5", point: {border: "#488EA5", background: "#DAEAEF"}},
    chart: {line: "#9582C4", point: {border: "#9582C4", background: "#E8E4F4"}},
    chart2: {line: "#ea580c", point: {border: "#ea580c", background: "#fed7aa"}},
    chart3: {line: "#9f1239", point: {border: "#9f1239", background: "#fecdd3"}},
    chart4: {line: "#075985", point: {border: "#075985", background: "#7dd3fc"}},
} as const;

export const animations = {
    pulse: {
        "0%": {transform: "rotate(0deg)"},
        "100%": {transform: "rotate(359deg)"},
    },
    flipInX: {
        from: {
            transform: "perspective(400px) rotate3d(1, 0, 0, 90deg)",
            animationTimingFunction: "ease-in",
            opacity: 0,
        },
        "40%": {
            transform: "perspective(400px) rotate3d(1, 0, 0, -20deg)",
            animationTimingFunction: "ease-in",
        },
        "60%": {
            transform: "perspective(400px) rotate3d(1, 0, 0, 10deg)",
            opacity: 1,
        },
        "80%": {
            transform: "perspective(400px) rotate3d(1, 0, 0, -5deg)",
        },
        to: {
            transform: "perspective(400px)",
        },
    },
} as const;

export const appStyles = {
    app: "flex flex-col w-full items-center flex-1 [-webkit-touch-callout:none] [-webkit-text-size-adjust:none] select-none",
    navigationAndManager:
        "w-full bg-stone-50 [&>*]:border-b [&>*]:border-[#D8D8D8] [&>*:last-child]:border-b-0",
};

export const commonColors = {
    primaryBackground: "#FBE8E1", // Used on buttons right now.
    // primaryBackgroundHover: "#75AEEC", // used when hovering over a button, also tab bar highlight when selected. And selected icons as well.
    primaryBackgroundHover: "#4FAFE5", // used when hovering over a button, also tab bar highlight when selected. And selected icons as well.
    buttonText: "#373A3C", // On primary buttons. How this does relate to text, etc?
    text: "#333",
    primary: "#008CBA",
    // border: "#CCC",
    disabled: "#DDD",
    readOnly: "#e6e6e6",

    // TODO: Old references, can be removed later.
    errorBorderColor: colors.error.border,
    errorBgColor: colors.error.background,
    errorFontColor: colors.error.text,
};
